import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataIoService } from '../../../services/data-io.service';
import { IconBarService } from '../../../services/icon-bar.service';
import { MenuService } from '../../../services/menu.service';

@Component({
  selector: 'basic-icon-bar',
  templateUrl: './icon-bar.component.html',
  styleUrls: ['./icon-bar.component.scss']
})
export class IconBarComponent implements OnInit {

  constructor(
    private menuService:MenuService, 
    private ioService: DataIoService,
    private iconbarService: IconBarService) {
    let knownIcons = [ 'ecomode', 'heating', 'dhw', 'operationTime', 'burner' ];
    this.iconbarService.registerIcons(knownIcons);
    this.iconbarService.enableIcon('heating');
    this.iconbarService.enableIcon('dhw');
    this.iconbarService.enableIcon('operationTime');
    this.iconbarService.enableIcon('burner'); 
    this.iconbarService.enableIcon('ecomode'); 

    this.iconbarService.blinkIcon('heating');
  }

  get disabled():boolean{
    return (!this.iconbarService.barEnabled());
  }

  getClasses(icon:string){
    if(this.disabled){
      return 'off';
    }
    return this.iconbarService.getState(icon);
  }

  ngOnInit() {

  }

}